import { render, staticRenderFns } from "./KpisDashboard.vue?vue&type=template&id=19f7b5e0&scoped=true"
import script from "./KpisDashboard.vue?vue&type=script&lang=js"
export * from "./KpisDashboard.vue?vue&type=script&lang=js"
import style0 from "./KpisDashboard.vue?vue&type=style&index=0&id=19f7b5e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f7b5e0",
  null
  
)

export default component.exports